/**
 * Uses the scale domain to check the type of data.
 *
 * If domainValues[0] ends up being null, we will return string. Since null
 * can only be value on ordinal axis.
 */
export default function getAxisDataType(scale) {
  const domainValues = scale.domain();
  if (domainValues.length === 0) return 'string';
  if (domainValues[0] instanceof Date || domainValues[domainValues.length - 1] instanceof Date) return 'time';else if (typeof domainValues[0] === 'number') {
    return 'number';
  } else {
    return 'string';
  }
}